import type { ValidationConfig } from '../../../core/dataProcessor/types';

type TreeNode = {
  name: string;
  children?: TreeNode[];
  [key: string]: unknown;
};

// 🆕 为新 ValidationEngine 导出的配置
export const treeValidationConfig: ValidationConfig = {
  fields: [
    // Tree使用特殊的层次数据结构，不使用常规字段验证
  ],
  businessRules: [
    {
      name: 'tree-hierarchical-structure',
      validator: (data, layer) => {
        // 🆕 data 已经是非表格数据（树形结构）
        if (!data || typeof data !== 'object') {
          return false;
        }

        // 递归验证节点结构
        function validateTreeNode(node: TreeNode): boolean {
          if (typeof node.name !== 'string' || !node.name) {
            return false;
          }

          if (node.children) {
            if (!Array.isArray(node.children)) {
              return false;
            }
            return node.children.every(child => validateTreeNode(child));
          }

          return true;
        }

        return validateTreeNode(data as TreeNode);
      },
      message:
        'Tree data must have proper hierarchical structure with "name" property for each node',
      suggestion: 'Ensure each node has a "name" property and "children" array if applicable',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'tree-minimum-data-requirement',
      validator: data => {
        if (!data || typeof data !== 'object') {
          return false;
        }

        const rootNode = data as TreeNode;

        // 至少需要根节点有名称
        if (typeof rootNode.name !== 'string' || !rootNode.name) {
          return false;
        }

        // 计算总节点数（包括子节点）
        function countNodes(node: TreeNode): number {
          // 当前节点
          let count = 1;
          if (node.children && Array.isArray(node.children)) {
            count += node.children.reduce((sum, child) => sum + countNodes(child), 0);
          }
          return count;
        }

        // 至少需要2个节点才能形成树结构
        return countNodes(rootNode) >= 2;
      },
      message: 'Tree requires at least 2 nodes (root + at least one child)',
      suggestion: 'Add child nodes to the root node to create a meaningful tree structure',
      severity: 'warning'
    }
  ]
};
